export default "__VITE_ASSET__D1fNwPvz__"